import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { APIError, APIErrorCode } from "../utils/types";

type ErrorMessageProps = {
  error: APIError;
};

export const ErrorMessage = ({ error }: ErrorMessageProps) => {
  const defaultMessage =
    "Sorry, we've had a technical problem. Please refresh your page and try again.";

  const { message = defaultMessage, code } = error;

  return (
    <div data-testid="basket:alert">
      <Message
        type="error"
        title={
          code === APIErrorCode.STOCK_SOURCE_MISMATCH ? defaultMessage : message
        }
      />
    </div>
  );
};
